import React, { useState } from 'react';
import './LoginPage.css'; // Import updated CSS
import { useNavigate } from 'react-router-dom';
import { BaseURL } from '../../Utils/baseURL';
import { ReactComponent as Logo } from '../../images/Logo.svg';
import axios from 'axios';
import { message } from 'antd';
import Logo1 from '../../images/BhugolGIS.svg';
import Logo2 from '../../images/MMRCLogo.svg';

const LoginPage = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${BaseURL}/auth/login/`,
        { email, password },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      sessionStorage.setItem('token', response.data.token);
      message.success('Login successful!');
      navigate('/');
    } catch (error) {
      if (error.response) {
        message.error(error.response.data.message || 'Login failed! Please check your credentials.');
      } else {
        message.error('An unexpected error occurred.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-area">
      <div className="branding-section">
        <div className="brand-logo">
          <Logo aria-label="Company Logo" />
        </div>
        <p>Explore and monitor tree data with our Geo-Tagging portal.</p>
        <div className="comp-logo">
          <img src={Logo2} className="logo2" alt="MMRC Logo" />
          <img src={Logo1} className="logo1" alt="BhugolGIS Logo" />
        </div>
      </div>
      <div className="login-container">
        <form onSubmit={handleSubmit} aria-label="Login Form">
          {error && <p className="error" aria-live="assertive">{error}</p>}
          <div className="input-groups">
            <label htmlFor="email" className="sr-only">Email or Username</label>
            <div className="input-with-icon">
              <i className="fas fa-user" aria-hidden="true"></i>
              <input
                id="email"
                type="email"
                placeholder="User Name/Id"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                aria-required="true"
              />
            </div>
          </div>
          <div className="input-groups">
            <label htmlFor="password" className="sr-only">Password</label>
            <div className="input-with-icon password-wrapper">
              <i className="fas fa-lock" aria-hidden="true"></i>
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                aria-required="true"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>
          <div className="action-row">
            <div className="forgot-password">
              <a href="#">Forgot Password?</a>
            </div>
            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Signing In..' : 'Sign In'}
            </button>
          </div>
        </form>
      </div>
      </div>
    </div>
  );
};

// Add a simple CSS class for screen-reader-only labels
const styles = `
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;

// Inject styles (alternatively, add to LoginPage.css)
const styleSheet = document.createElement('style');
styleSheet.textContent = styles;
document.head.appendChild(styleSheet);

export default LoginPage;